import { useAppSelector } from '@/hooks/appHook'
import { getUser } from '@/store/user/user'

const useLogged = () => {
  const user = useAppSelector(getUser)
  const isLoggedIn = !!user

  return {
    isLoggedIn
  }
}

export default useLogged
